export function selectionRequiresPlannedDate(selectedItems, saleItems) {
    if (selectedItems.length === 0 || saleItems.length === 0) {
        return false;
    }
    const saleItemById = new Map(saleItems.map((item) => [item.id, item]));
    return selectedItems.some((selected) => { var _a; return ((_a = saleItemById.get(selected.id)) === null || _a === void 0 ? void 0 : _a.requiresPlannedDate) === true; });
}
export function dealRequiresPlannedDate(dealItems, saleItems) {
    if (dealItems.length === 0 || saleItems.length === 0) {
        return false;
    }
    const saleItemById = new Map(saleItems.map((item) => [item.id, item]));
    return dealItems
        .filter((dealItem) => !dealItem.proposed)
        .some((dealItem) => { var _a, _b, _c; return ((_c = saleItemById.get((_b = (_a = dealItem.item) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '')) === null || _c === void 0 ? void 0 : _c.requiresPlannedDate) === true; });
}
